export const en = {
  en: {
    translation: {
      Signin: 'Signin',
    },
  },
};
